/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ComponentExpenseCustomer from './ComponentExpenseCustomer';
import ComponentExpenseMainTable from './ComponentExpenseMainTable';
import { ExpenseReports } from '../../types';
import ComponentExpenseAnalystTable from './ComponentExpenseAnalystTable';
import { RootState } from '../../../../redux/rootState';
import ComponentTotalExpenseTable from './ComponentTotalExpenseTable';

function ExpenseReport({ isMorning, dataItem }: { isMorning?: boolean, dataItem?: ExpenseReports[] }) {
  const { reportPdfResponse4 } = useSelector((state: RootState) => state.reportPdfSliceReducer);
  const data = useMemo(() => (isMorning ? dataItem : reportPdfResponse4?.Expense_Report), [isMorning, dataItem, reportPdfResponse4]);

  return (
    <>
      {data?.map((item: ExpenseReports, index: number) => (
        <>
          {/* Only render if ExpenseReports is not empty */}
          {item.ExpenseReports.length > 0 && (
          <>
            {index > 0 && (data?.[index - 1]?.ExpenseReports?.length > 0) && <div className="page-break" />}
            <div className="ExpenseReportPDFDiv">
              <div className="pageHeader">
                <div className="underlineHeadingText textCenter pb10">{`Expense Report ${index === 0 && data?.length > 1 ? '(A - ' : (index === 1 ? '(B - ' : (index === 2 ? '(C - ' : '('))}${item?.JobOrder})`}</div>
              </div>
              <ComponentExpenseCustomer customerData={item.Customerdata} />
              <ComponentExpenseMainTable mainTableData={item} />
              <ComponentExpenseAnalystTable expenseAnalystTable={item} />
              {reportPdfResponse4?.Expense_Report?.length > 1 && index === data.length - 1 && <ComponentTotalExpenseTable />}
            </div>
          </>
          )}
          {item.ExpenseReports.length === 0 && isMorning && (
          <>
            {index > 0 && (data?.[index - 1]?.ExpenseReports?.length > 0) && <div className="page-break" />}
            <div className="ExpenseReportPDFDiv">
              <div className="pageHeader">
                <div className="underlineHeadingText textCenter pb10">{`Expense Report ${index === 0 && data?.length > 1 ? '(A - ' : (index === 1 ? '(B - ' : (index === 2 ? '(C - ' : '('))}${item?.JobOrder})`}</div>
              </div>
            </div>
          </>
          )}
        </>
      ))}

    </>
  );
}

export default ExpenseReport;
